module.exports = __webpack_public_path__ + "static/img/consumer.36dca0b2.jpg";